import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import cx from 'classnames';

import Button from 'base/components/Button';
import TextField from './TextField';
import Select from './Select';
import RadioGroup from './RadioGroup';

import { shirtSizes, departments, allDepartments, transportHours } from 'modules/User/const';

class EntryForm extends Component {
    render() {
    const { partner, handleSubmit, isSubmitting, hidden, readOnly } = this.props;
    const formStyles = cx('entryform-form', {
      'entryform--hidden': hidden
    });

    return (
        <form
          className={formStyles}
          onSubmit={handleSubmit}
        >
          <Field
            label="Imię"
            // eng="Name"
            name="name"
            component={TextField}
            required
            readOnly={readOnly}
          />

          <Field
            label="Nazwisko"
            // eng="Surname"
            name="surname"
            component={TextField}
            required
            readOnly={readOnly}
          />

          <Field
            label="Jestem studentem W8"
            // eng="Sex"
            name="izet"
            options={[{
              label: 'Tak',
              value: 'true',
              name: 'izet'
            },
            {
              label: 'Nie',
              value: 'false',
              name: 'izet'
            }
            ]}
            component={RadioGroup}
            required
            readOnly={readOnly}
          />

          <Field
            label="Numer indeksu"
            // eng="Index"
            name="index"
            component={TextField}
            pattern="[0-9]{6}"
            title="Indeks w formacie 000000"
            required
            readOnly={readOnly}
          />

          <Field
            label="E-mail"
            // eng="E-mail"
            name="mail"
            type="email"
            component={TextField}
            required
            readOnly={readOnly}
          />

          <Field
            label="Numer telefonu"
            // eng="Phone number"
            name="phoneNumber"
            type="tel"
            component={TextField}
            pattern="[0-9]{9}"
            title="Numer telefonu w formacie 000000000"
            required
            readOnly={readOnly}
          />

          <Field
            label="Rodzaj diety"
            name="diet"
            options={[{
              label: 'Mięsna',
              value: 'meat',
              name: 'diet'
            },
            {
              label: 'Bezmięsna',
              value: 'vege',
              name: 'diet'
            }
            ]}
            component={RadioGroup}
            required
          />

          <Field
            label="Czy idziesz z osobą towarzyszącą?"
            // eng="Sex"
            name="partner"
            options={[{
              label: 'Tak',
              value: 'true',
              name: 'partner'
            },
            {
              label: 'Nie',
              value: 'false',
              name: 'partner'
            }
            ]}
            component={RadioGroup}
            required
            readOnly={readOnly}
          />

          {partner === 'true' && (
            <React.Fragment>
              <p className="partner-header">Dane osoby towarzyszącej</p>
              <Field
                label="Imię osoby tow."
                name="partnerName"
                component={TextField}
                required
                readOnly={readOnly}
              />
              <Field
                label="Nazwisko osoby tow."
                name="partnerSurname"
                component={TextField}
                required
                readOnly={readOnly}
              />
              <Field
                label="Czy osoba tow. jest z W8?"
                // eng="Sex"
                name="partnerIzet"
                options={[{
                  label: 'Tak',
                  value: 'true',
                  name: 'partnerIzet'
                },
                {
                  label: 'Nie',
                  value: 'false',
                  name: 'partnerIzet'
                }
                ]}
                component={RadioGroup}
                required
                readOnly={readOnly}
              />
              <Field
                label="E-mail osoby tow."
                name="partnerMail"
                type="email"
                component={TextField}
                required
                readOnly={readOnly}
              />
              <Field
                label="Rodzaj diety dla osoby tow."
                name="partnerDiet"
                options={[{
                  label: 'Mięsna',
                  value: 'meat',
                  name: 'partnerDiet'
                },
                {
                  label: 'Bezmięsna',
                  value: 'vege',
                  name: 'partnerDiet'
                }
                ]}
                component={RadioGroup}
                required
              />
            </React.Fragment>
          )}

          <p className="terms">
            Wysłanie zgłoszenia oznacza zapoznanie się i akceptację{' '}
            <a className="acid-link" href="https://drive.google.com/file/d/1vP4MPW8th6gth7MPFYGdOlxK2rhtPBx2/view" target="_blank">regulaminu balu</a>.
          </p>

          {
            !readOnly &&
            <Button disable={isSubmitting} acid>Wyślij</Button>
          }
        </form>
    );
  }
};

let Form = reduxForm({
  form: 'entry'
})(EntryForm);

const selector = formValueSelector('entry') // <-- same as form name
Form = connect(
  state => {
    // can select values individually
    // const hasEmailValue = selector(state, 'hasEmail')
    const partner = selector(state, 'partner')
    // or together as a group
    return {
      partner
    }
  }
)(Form)

export default Form



// WEBPACK FOOTER //
// ./src/modules/User/components/EntryForm.js